import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import Autocomplete from 'Components/UI/Autocomplete';

export const metaOverrideSet = fr.metaOverride({ BaseOverride })
  .nameOverride(['limit', 'offset', 'sort'], { hidden: true })
  .typeOverride('picklist', {
    _component: () => Autocomplete,
  });
